import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_ITEMS = [
  { label: "Biografie", href: "#biografie" },
  { label: "Musik", href: "#musik" },
  { label: "Live & Medien", href: "#live" },
  { label: "Bühnen 2026", href: "#buehnen" },
  { label: "Booking", href: "#booking" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-brand"
          className="flex items-baseline gap-2 group"
        >
          <span className="font-display text-xl md:text-2xl tracking-wide text-white">
            Daniel
          </span>
          <span className="font-display italic text-xl md:text-2xl tracking-wide text-[#D4AF37] group-hover:text-[#F3E5AB] transition-colors">
            Lopes
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.href.replace("#", "")}`}
              className="text-xs tracking-[0.22em] uppercase text-[#A3A3A3] hover:text-[#D4AF37] transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#booking"
          data-testid="nav-booking-cta"
          className="!hidden md:!inline-flex btn-primary py-3 px-6 text-[0.7rem]"
        >
          Jetzt anfragen
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((s) => !s)}
          className="md:hidden text-white p-2"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="md:hidden bg-[#0A0A0A] border-t border-white/5"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.22em] uppercase text-[#A3A3A3] hover:text-[#D4AF37]"
                data-testid={`nav-mobile-link-${item.href.replace("#", "")}`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="#booking"
              onClick={() => setOpen(false)}
              className="btn-primary mt-2 self-start"
              data-testid="nav-mobile-booking-cta"
            >
              Jetzt anfragen
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
